class HeaderCheckoutController {
    constructor(breakpointsService, shopPageStateService, trolleyService) {
        this.breakpointsService = breakpointsService;
        this.shopPageStateService = shopPageStateService;
        this.trolleyService = trolleyService;
    }

    back() {
        window.history.back();
    }

    toggleCartOpen() {
        this.shopPageStateService.isCartOpen = !this.shopPageStateService.isCartOpen;
    }
}

const headerCheckoutComponentDefinition = {
    controller: ['BreakpointsService', 'ShopPageStateService', 'TrolleyService', HeaderCheckoutController],
    template: require('./header-checkout.component.html').trim(),
};

module.exports = {
    HeaderCheckoutController,
    headerCheckoutComponentDefinition,
};



// WEBPACK FOOTER //
// ./src/shop/header/header-checkout.component.js